var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 7",
    x1: 4.37114e-8,
    y1: 0.5,
    x2: 13,
    y2: 0.500001,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line 9",
    x1: 4.37114e-8,
    y1: 8.5,
    x2: 13,
    y2: 8.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 8",
    x1: 4.37114e-8,
    y1: 4.5,
    x2: 17,
    y2: 4.5,
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerWhite);
export default __webpack_public_path__ + "static/media/hamburger_white.a881bc3580d87c041cd8e17cca379301.svg";
export { ForwardRef as ReactComponent };